import { AfterViewInit, ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  FormGroupDirective,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzSelectComponent } from 'ng-zorro-antd/select';

import { BirEditModalComponent } from '../../modal/bir-edit-modal/bir-edit-modal.component';
import { BirExistModalComponent } from '../../modal/bir-exist-modal/bir-exist-modal.component';
import { BirReplaceModalComponent } from '../../modal/bir-replace-modal/bir-replace-modal.component';
import { SelectBaseComponent } from '../select-base';
import { SelectInstantBaseNewComponent } from '../selectInstant-base-new';

@Component({
  selector: 'app-supplier-bir-select',
  templateUrl: './supplier-bir-select.component.html',
  styles: [
    `
      [nz-icon] {
        cursor: pointer;
      }
      .supplier-bir-select-container {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .edit-button-container {
        flex-shrink: 0;
      }
      .add-new-button {
        width: 100%;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SupplierBirSelectComponent),
      multi: true
    }
  ]
})
export class SupplierBirSelectComponent extends SelectInstantBaseNewComponent implements OnInit, AfterViewInit {
  override jump(): string | undefined {
    // throw new Error('Method not implemented.');
    return '';
  }
  override queryParam(): String {
    // throw new Error('Method not implemented.');
    return '';
  }
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;
  @ViewChild(BirExistModalComponent) birExistModal!: BirExistModalComponent;
  @ViewChild(BirEditModalComponent) birEditModal!: BirEditModalComponent;
  @ViewChild(BirReplaceModalComponent)
  birReplaceModal!: BirReplaceModalComponent;

  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    private formGroup: FormGroupDirective,
    private container: ControlContainer,
    private modalSrv: NzModalService,
    router: Router,
    private reuseTabService: ReuseTabService
  ) {
    super(http, cdr, router);
    this.valueField = '';
  }
  address: any = {};

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
    
    // Listen to search form changes to store instant data
    this.searchForm.controls.keyword.valueChanges.subscribe(value => {
      if (value) {
        this.storedInstantData = value.trim();
      }
    });

    // Ensure the correct item is active whenever the list updates while open
    this.onListFilled.subscribe(() => {
      if ((this.nzSelectComponent as any)?.nzOpen) {
        this.ensureFirstItemActivatedAndFocused();
      }
    });
  }

  ngAfterViewInit(): void {
    // Additional initialization if needed
    // This method is required by AfterViewInit interface
    // Initialize any view-specific logic here if needed
    this.cdr.detectChanges();
  }

  updateBIRRelatedInfo(birInfo: any) {
    const formData = this.formGroup.value;

    const birRelatedValues: any = {};
    birRelatedValues.registrationNo = birInfo.tinNumber;
    birRelatedValues.tinBranchCode = birInfo.tinBranchCode;

    if (birInfo.address) {
      const addresses = (<string>birInfo.address).split(', ');
      if (addresses.length > 0) birRelatedValues.address1 = addresses[0];
      else birRelatedValues.address1 = null;

      if (addresses.length > 1) birRelatedValues.address2 = addresses[1];
      else birRelatedValues.address2 = null;

      if (addresses.length > 2) birRelatedValues.address2 += addresses[2];
    }
    birRelatedValues.address3 = birInfo.district;
    birRelatedValues.zipCode = birInfo.zipCode;

    let newValues: any = {};
    for (let key of Object.keys(birRelatedValues)) {
      if (formData[key] !== birRelatedValues[key]) {
        newValues[key] = birRelatedValues[key];
      }
    }

    // if (Object.keys(newValues).length) {
    //   const form = this.formControl.control.parent;
    //   const modalRef = this.modalSrv.confirm({
    //     nzTitle: 'Record did not matched.',
    //     nzContent:
    //       'Do you want to replace existing TIN, Address, and Zip Code?',
    //     nzOnOk: () => {
    //       form?.patchValue(newValues);
    //       modalRef.destroy();
    //     },
    //     nzOnCancel: () => {
    //       modalRef.destroy();
    //     }
    //   });
    // }
  }

  getUrl(searchValue: string): string {
    let filter = `IsCompany ne true and IsAP eq true`;
    if (searchValue) {
      const searchFields = [
        'code',
        'companyName',
        'firstName',
        'middleName',
        'lastName',
        'tinNumber',
        'tinBranchCode',
        'address'
      ];
      const searchStr = searchValue.replaceAll("'", "''");
      const searchFilter = searchFields
        .map(x => `contains(${x}, '${encodeURIComponent(searchStr)}')`)
        .join(' or ');
      filter = `(${filter}) and (${searchFilter})`;
    }
    return `api/BIRClassifications/Query?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
  }

 
  override addNew() {
    const formData = this.formGroup.value;
    if (!formData.registrationNo || !formData.tinBranchCode) {
      this.modalSrv.warning({
        nzTitle: 'TIN is required.',
        nzContent:
          'TIN and TIN Branch Code are required before adding New BIR Info Record.'
      });
      return;
    }
    this.address = [formData.address1, formData.address2].filter(Boolean).join(', ');
    const birPayload = {
      tinNumber: formData.registrationNo,
      tinBranchCode: formData.tinBranchCode,
      isAP: true,
      address: this.address,
      district: formData.address3,
      zipCode: formData.zipCode
    };
    const skipExistCheck =
      formData.registrationNo === '000-000-000' &&
      (formData.tinBranchCode === '0000' || formData.tinBranchCode === '00000');
    if (skipExistCheck) {
      this.birEditModal.show(birPayload);
      return;
    }
    const filter = `IsCompany ne true and IsAP eq true and tinNumber eq '${formData.registrationNo}' and tinBranchCode eq '${formData.tinBranchCode}'`;

    this.http
      .get(`api/BIRClassifications/Query?_silent=true&$top=1&$filter=${filter}`)
      .subscribe(res => {
        if (res.value?.length) {
          this.birExistModal.show(res.value[0]);
        } else {
          this.birEditModal.show(birPayload);
        }
      });
  }

  selectBir(data: any) {
    if (data) {
      const newValues = this.getBirUpdateValues(data);
      if (Object.keys(newValues).length > 0) {
        this.birReplaceModal.show(data);
      }
      if (data.id) {
        if (data.isUpdate) {
          this.http.post('api/BIRClassifications/update', data).subscribe(res => {
            this.list = this.list.map(item => // update list via new value item
              item.id === res.id ? res : item
            );
            this.valueChanged(res);
          });
        } else {
          this.valueChanged(data);
        }
      } else {
        this.http.post('api/BIRClassifications/create', data).subscribe(res => {
          if (res) {
            this.list.push(res);
            this.valueChanged(res);
          }
        });
      }
    } else {
      this.valueChanged(null);
    }
  }

  replaceBir(data: any) {
    const form = <FormGroup>this.container.control;
    const newValues = this.getBirUpdateValues(data);
    form.patchValue(newValues);
  }

  editBir() {
    this.birEditModal.show(this.value);
  }

  private getBirUpdateValues(birInfo: any): any {
    const formData = this.formGroup.value;

    const birRelatedValues: any = {};
    birRelatedValues.registrationNo = birInfo.tinNumber;
    birRelatedValues.tinBranchCode = birInfo.tinBranchCode;

    if (birInfo.address) {
      const addresses = (<string>birInfo.address).split(', ');
      if (addresses.length > 0) birRelatedValues.address1 = addresses[0];
      else birRelatedValues.address1 = null;

      if (addresses.length > 1) birRelatedValues.address2 = addresses[1];
      else birRelatedValues.address2 = null;

      if (addresses.length > 2) birRelatedValues.address2 += addresses[2];
    }
    birRelatedValues.address3 = birInfo.district;
    birRelatedValues.zipCode = birInfo.zipCode;

    let newValues: any = {};
    for (let key of Object.keys(birRelatedValues)) {
      if (!formData[key] && !birRelatedValues[key]) continue;
      if (formData[key] !== birRelatedValues[key]) {
        newValues[key] = birRelatedValues[key];
      }
    }
    return newValues;
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.reuseTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }


}
